import React from 'react';

import { useGetSupplier } from '~/hooks/apis/tours/useTourSuppliers';

import { TourService } from '~/types/tours/costPrice';

interface Props {
  service: TourService;
}

export default function TourServiceOptionLabel({ service }: Props) {
  const { data: supplier, error } = useGetSupplier(service.supplierId);
  const supplierName = supplier?.name ?? (error ? 'Supplier unavailable' : 'Loading supplier…');

  return (
    <>
      {supplierName} — {service.name} ({service.kind})
    </>
  );
}
